/* tslint:disable */
/* eslint-disable */
/**
 * Registration API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewPasswordRequest
 */
export interface NewPasswordRequest {
    /**
     * The email of the account for which to renew the password
     * @type {string}
     * @memberof NewPasswordRequest
     */
    email: string;
    /**
     * The new password to use
     * @type {string}
     * @memberof NewPasswordRequest
     */
    newPassword: string;
}

/**
 * Check if a given object implements the NewPasswordRequest interface.
 */
export function instanceOfNewPasswordRequest(value: object): value is NewPasswordRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('newPassword' in value) || value['newPassword'] === undefined) return false;
    return true;
}

export function NewPasswordRequestFromJSON(json: any): NewPasswordRequest {
    return NewPasswordRequestFromJSONTyped(json, false);
}

export function NewPasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewPasswordRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'newPassword': json['newPassword'],
    };
}

export function NewPasswordRequestToJSON(value?: NewPasswordRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'newPassword': value['newPassword'],
    };
}

